/**
 * @description Table
 * @props {Array} headers - content within th tags
 * @props {Array} data - content within td tags
 * @props {Array} values (optional) - if data comes from object, allows to link key/values
 * @props {Array} navigation (optional) - horizontal navigation
 * @props {String} filterTag (optional) - custom labeling  
 * @props {Array} sortBy - sort columns
 * @props {Number} length - slices rows at desired length
 **/

import React, { Component } from 'react';
import _ from 'lodash';
import { labelIsValid } from '~/tools/mll/helpers'
import './index.scss';

class Table extends Component {
  state = {
    loaded: false,
    arrow: true,
  }

  componentWillReceiveProps = (props) => {
    if (props !== this.props) {
      this.setState({ 
        data: props.data, 
        loaded: !!props.data.length,
        length: props.length || 5
      })
    }
  }

  componentDidMount = () => {
    if (this.props !== undefined) {
      this.setState({ 
        data: this.props.data, 
        loaded: !!this.props.data.length,
        length: this.props.length || 5
      })
    }
  }

  navigateData = (dir, array) => {
    this.index = _.findIndex(array, this.state.data[0])

    if (dir === 'next') {
      this.index = this.index <= array.length - this.state.length ? 
      this.index + this.state.length : this.index
    } else {
      this.index = this.index < 0 ? 
      0 : this.index - this.state.length
    }

    const copy = array.map(el => el);
    const sliced = copy.slice(this.index, this.index + this.state.length);

    if (sliced.length) {
      this.setState({ data: sliced })
    }
  }

  sortRows = (key) => {
    let sorted = this.state.data.sort((a, b) => 
    this.state.arrow ? b[key] - a[key] : a[key] - b[key]);
    this.setState({
      data: sorted,
      arrow: !this.state.arrow         
    })
  }

  navigationMenu = () => {
    return (
      <div className='table-navigation'>
        <div onClick={() => this.navigateData('left', this.props.navigation)}>
          <span>Prev.</span>
        </div>
        <div onClick={() => this.navigateData('next', this.props.navigation)}>
          <span>Next</span>
        </div>
      </div>
    )
  }

  renderRawData = (data, headers) => {
    const sliced = index => (index * headers.length)
    return (
      [...Array(Math.ceil(data.length / headers.length))].map((d, i) => (
        <tr key={i}>
          {this.props.data.slice(sliced(i), sliced(i) + headers.length).map((label, i) => (
            <td key={i}>{label}</td>
          )) }
        </tr>  
      ))
    )
  } 

  render() {
    const Label = ({ data, value }) => <td>{ labelIsValid(data, value) ? data[value] : 'N/A' }</td>
    const sortBy = this.props.sortBy;
    const isSorted = header => sortBy && sortBy.length && header === sortBy[0]
    const isCustomLabeled = value => this.props.filterTag && value === this.props.filterTag

    return (
      <div>
        { this.state.loaded ?
          <div> 
            <table className='table-content' cellSpacing='0'>
              <tbody>
                <tr className='table-headers'>
                  { this.props.headers && this.props.headers.map((header, i) => (
                    isSorted(header) ?
                      <th key={i} className='table-sort' onClick={() => this.sortRows(sortBy[1])}>
                        <span>{header} <i className={`ion-arrow-${this.state.arrow? 'down' : 'up'}-b`}></i></span>
                      </th> : <th key={i}><span>{header}</span></th>
                  )) }
                </tr>
                { this.props.values ? 
                    this.state.data.slice(0, this.state.length).map((data, i) => (
                      <tr className='table-info' key={i}>
                        { this.props.values.map((value, i) => (
                          isCustomLabeled(value) ? 
                            <this.props.filter key={i} data={data} value={value} /> :
                            <Label key={i} data={data} value={value} />
                        )) }
                      </tr>
                    )) : this.renderRawData(this.props.data, this.props.headers) }              
              </tbody>
            </table> 
            { this.props.navigation ? this.navigationMenu() : <div /> }
          </div> : <div />
        }
      </div>
    )
  }
}

export default Table;